import React from 'react';
import { View } from 'react-navi';
import { mount, compose, withView, redirect } from 'navi';
import ReactGA from 'react-ga';
import ProfileApp from './profiles';
import ListApp from './list';

const apps = compose(
  withView((request: any) => {
    if (process.env.REACT_APP_CONTEXT === 'production') {
      ReactGA.pageview(request.path);
    }
    return (
      <>
          <div className="is-frecam cpck-window cpck-banner cpck-type-info cpck-theme-block cpck-bottom">
              <span id="cupcakeconsent:desc" className="cpck-message"><strong className="has-text-weight-bold">2025年度 新1年生募集中！</strong><br />早期エントリーであなたの夢を応援する特典動画をGET!</span>
              <div className="cpck-compliance">
                  <a aria-label="dismiss cookie message"
                      href="https://entry.miscolle.com/gateway?utm_source=frecam2021&utm_medium=operation"
                      className="cpck-btn cpck-dismiss"><span>🌸</span>エントリー方法を確認する</a>
              </div>
          </div>
          <View />
      </>
    );
  }),
  mount({
    '/': redirect('/list'),
    '/list': ListApp,
    '/entry': ProfileApp,
  }),
);

export default apps;
